const getUsedPercentValue = (finalValue, percent, availableValue) => {
  const maxCashbackValue = Math.floor(finalValue * 100 * (percent / 100)) / 100;

  return Math.min(maxCashbackValue, availableValue);
};

export default getUsedPercentValue;
